"use client"

import * as React from "react"
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react"

import { cn } from "@/lib/utils"
import { Tip } from "@/components/ui/tip"

import {
  FILL_BLANK_CHIP_CLASS,
  FILL_BLANK_CHIP_HIGHLIGHT_CLASS,
} from "./fill-blank-html"
import { useQuestionComposerContext } from "./composer-context"

export function FillBlankChipNodeView(props: NodeViewProps) {
  const label = Number(props.node.attrs.label) || 1
  const index = label - 1
  const { fillBlankHighlight } = useQuestionComposerContext()
  const highlighted = fillBlankHighlight.isHighlighted(index)

  return (
    <NodeViewWrapper as="span" className="inline">
      <Tip side="top" label={`Highlight accepted answers for blank ${label}`}>
        <button
          type="button"
          contentEditable={false}
          data-fill-blank={label}
          tabIndex={0}
          className={cn(
            FILL_BLANK_CHIP_CLASS,
            highlighted && FILL_BLANK_CHIP_HIGHLIGHT_CLASS,
            props.selected && "ring-2 ring-ring",
          )}
          onMouseEnter={() => fillBlankHighlight.setHoverIndex(index)}
          onMouseLeave={() => fillBlankHighlight.setHoverIndex(null)}
          onFocus={() => fillBlankHighlight.setSelectedIndex(index)}
          onClick={(event) => {
            event.preventDefault()
            fillBlankHighlight.focusAnswerRow(index)
          }}
        >
          Blank {label}
        </button>
      </Tip>
    </NodeViewWrapper>
  )
}
